import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule } from '@angular/common/http';
import { AppointmentComponent } from './appointment/appointment.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service'
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material-module';
import { AppComponent } from './app.component';

import { AppointmentConfirmationDialog } from './appointment/appointment.confirmation-dialog';
import { AddAppointmentComponent } from './add-appointment/add-appointment.component';



@NgModule({
    declarations: [
        AppComponent,
        AppointmentComponent,
        AppointmentConfirmationDialog,
        AddAppointmentComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MaterialModule,
        CommonModule,
        ToastrModule.forRoot()
    ],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'nl-BE' }, CookieService],
    bootstrap: [AppComponent]
})
export class AppModule { }
